/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegionPrefecture
 */
export interface RegionPrefecture {
    /**
     * 都道府県のID。pref_idに相当
     * @type {string}
     * @memberof RegionPrefecture
     */
    prefectureId: string;
    /**
     * 都道府県名
     * @type {string}
     * @memberof RegionPrefecture
     */
    prefectureName: string;
}

export function RegionPrefectureFromJSON(json: any): RegionPrefecture {
    return RegionPrefectureFromJSONTyped(json, false);
}

export function RegionPrefectureFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegionPrefecture {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prefectureId': json['prefecture_id'],
        'prefectureName': json['prefecture_name'],
    };
}

export function RegionPrefectureToJSON(value?: RegionPrefecture | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'prefecture_id': value.prefectureId,
        'prefecture_name': value.prefectureName,
    };
}

